export default "__VITE_ASSET__80bd26fd__"